'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _onboardFormValidation = require('utils/onboardFormValidation');

var _components = require('components');

var _auth = require('redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterForm = (_dec = (0, _reduxForm.reduxForm)({
  fields: ['email', 'password', 'confirmPassword'],
  form: 'onboard',
  validate: _onboardFormValidation.validate,
  asyncValidate: _onboardFormValidation.asyncValidate,
  asyncBlurFields: ['email']
}, function (state) {
  return {
    checkingIfExists: state.auth.checkingIfExists,
    checkedIfExists: state.auth.checkedIfExists,
    checkedIfExistStatus: state.auth.checkedIfExistStatus
  };
}, { checkIfExists: _auth.checkIfExists }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(RegisterForm, _React$Component);

  function RegisterForm() {
    (0, _classCallCheck3.default)(this, RegisterForm);
    return (0, _possibleConstructorReturn3.default)(this, (RegisterForm.__proto__ || (0, _getPrototypeOf2.default)(RegisterForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(RegisterForm, [{
    key: 'render',
    value: function render() {
      var styles = require('./RegisterForm.scss');
      var _props = this.props,
          submitTitle = _props.submitTitle,
          checkingIfExists = _props.checkingIfExists,
          checkedIfExists = _props.checkedIfExists,
          checkedIfExistStatus = _props.checkedIfExistStatus,
          error = _props.error,
          submitting = _props.submitting,
          handleSubmit = _props.handleSubmit,
          _props$fields = _props.fields,
          email = _props$fields.email,
          password = _props$fields.password,
          confirmPassword = _props$fields.confirmPassword;


      var existStatus = checkedIfExistStatus && checkedIfExists === email.value ? checkedIfExistStatus.code : error && error.code || '';

      var isSubmitDisabled = checkingIfExists === email.value || submitting;

      return _react2.default.createElement(
        'form',
        { className: styles.RegisterForm, onSubmit: handleSubmit },
        _react2.default.createElement(
          'div',
          { className: styles['RegisterForm__fields'] },
          _react2.default.createElement(_components.TextInput, (0, _extends3.default)({
            validating: checkingIfExists === email.value,
            type: 'email',
            ref: 'email',
            title: 'Your Email Address',
            className: styles['RegisterForm__input--email'] }, email)),
          _react2.default.createElement(_components.TextInput, (0, _extends3.default)({
            type: 'password',
            ref: 'password',
            title: 'Create a new password',
            className: styles['RegisterForm__input--password'] }, password))
        ),
        existStatus == 'AccountPasswordNotSet' && _react2.default.createElement(
          'span',
          { className: styles['RegisterForm__emailMessage'] },
          'You already have an account with us! (most likely from a previous Quixel Suite purchase.)',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          'Please check your email for further instructions on how to login.'
        ),
        error && error.code == 'IncorrectPassword' && _react2.default.createElement(
          'span',
          { className: styles['RegisterForm__emailMessage'] },
          'Email address or password looks incorrect. Can you please confirm and try again?'
        ),
        error && error.code == 'PasswordRequired' && _react2.default.createElement(
          'span',
          { className: styles['RegisterForm__emailMessage'] },
          'You already seem to have an account with us!',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          'Please try logging in instead!'
        ),
        _react2.default.createElement(
          'footer',
          { className: styles.RegisterForm__action },
          _react2.default.createElement(_components.Button, {
            primary: true,
            disabled: isSubmitDisabled,
            label: submitTitle })
        )
      );
    }
  }]);
  return RegisterForm;
}(_react2.default.Component), _class2.propTypes = (0, _extends3.default)({}, _reduxForm.propTypes, {
  submitTitle: _react2.default.PropTypes.string
}), _class2.defaultProps = {
  submitTitle: 'Sign up'
}, _temp)) || _class);
exports.default = RegisterForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RegisterForm/RegisterForm.jsx
// module id = 2461
// module chunks = 0